import { initPriceRange } from '@theme/snippet-price-range-script';

/**
 * @typedef {HTMLElement & { prepareForSubmission?: () => void }} PriceRangeElement
 */

/**
 * @param {HTMLFormElement} formElement
 */
function submitFilterForm(formElement) {
  formElement.querySelectorAll('[data-price-range]').forEach((element) => {
    const priceRange = /** @type {PriceRangeElement} */ (element);
    if (typeof priceRange.prepareForSubmission === 'function') {
      priceRange.prepareForSubmission();
    }
  });

  if (typeof formElement.requestSubmit === 'function') {
    formElement.requestSubmit();
    return;
  }

  formElement.submit();
}

/**
 * @param {HTMLFormElement} form
 */
function initCollectionFilters(form) {
  if (form.dataset.collectionFiltersBound === 'true') {
    return;
  }

  form.dataset.collectionFiltersBound = 'true';

  form.querySelectorAll('[data-price-range]').forEach((root) => {
    if (root instanceof HTMLElement) {
      initPriceRange(root);
    }
  });

  form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
    input.addEventListener('change', () => {
      submitFilterForm(form);
    });
  });
}

document.querySelectorAll('.collection-filters').forEach((form) => {
  if (form instanceof HTMLFormElement) {
    initCollectionFilters(form);
  }
});
